/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_SharesInputs */

const cs_enum_shares = /** @type {(inputs: Enum_SharesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podíly`)
};

const en_enum_shares = /** @type {(inputs: Enum_SharesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shares`)
};

/**
* | output |
* | --- |
* | "Shares" |
*
* @param {Enum_SharesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_shares = /** @type {((inputs?: Enum_SharesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_SharesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_shares(inputs)
	return cs_enum_shares(inputs)
});